import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { Place } from '../data/smaken';
import { Stamp } from './Marks';
interface PlaceCardProps {
  place: Place;
  /** 'tall' for feature positions, 'wide' for editorial rows, 'plain' for grids. */
  ratio?: 'tall' | 'wide' | 'plain';
}
const priceLabel = (level: 1 | 2 | 3) => ['kr', 'kr kr', 'kr kr kr'][level - 1];
export function PlaceCard({
  place,
  ratio = 'plain'
}: PlaceCardProps) {
  const aspect = ratio === 'tall' ? 'aspect-[3/4]' : ratio === 'wide' ? 'aspect-[16/10]' : 'aspect-[4/3]';
  return <Link to={`/plats/${place.slug}`} className="group flex h-full flex-col" data-id="element-710" data-mp="3acg4w72uhmp7">
      <div className={`relative w-full overflow-hidden bg-black/5 ${aspect}`} data-id="element-711" data-mp="3fbj3p9s8ewoq">
        <img src={place.image} alt={place.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-[280ms] ease-out group-hover:scale-[1.03]" data-id="element-712" data-mp="3f9g3xy1a1p6t" />
        {place.stamp && <span className="absolute left-4 top-4 bg-papper/95 px-1" data-id="element-713" data-mp="3mekhudbdog4o">
            <Stamp data-id="element-714" data-mp="3hg98e3ozw7mz">{place.stamp}</Stamp>
          </span>}
      </div>

      <div className="flex flex-1 flex-col pt-4" data-id="element-715" data-mp="3hey13twcchr4">
        <div className="flex items-baseline justify-between gap-4" data-id="element-716" data-mp="3ddupjjlbt7vp">
          <h3 className="display-xl text-2xl uppercase sm:text-[1.75rem]" data-id="element-717" data-mp="38gm5fdgmatrt">{place.name}</h3>
          <ArrowUpRightIcon className="h-5 w-5 shrink-0 -translate-x-1 opacity-0 transition-[transform,opacity] duration-200 ease-out group-hover:translate-x-0 group-hover:opacity-100" aria-hidden="true" data-id="element-718" data-mp="33gq1fe7x72c9" />
        </div>

        <p className="mt-1.5 text-[11px] font-semibold uppercase tracking-wide2 text-black/50" data-id="element-719" data-mp="2trq2tvxby8yl">
          {place.city} · {place.tags.join(' · ')}
        </p>

        <p className="mt-3 text-[0.95rem] leading-relaxed text-black/70" data-id="element-720" data-mp="2kr1o0z0444kn">{place.blurb}</p>

        <p className="mt-auto pt-4 text-[11px] font-semibold uppercase tracking-wide2 text-black/40" data-id="element-721" data-mp="2fqvokwnlpds0">
          {priceLabel(place.price)}
        </p>
      </div>
    </Link>;
}